const prcct = typeof $ === "function" ? $("body").data("cmpprice") : undefined;
const fsProductDataMap = new WeakMap();

function normalizePathname(pathname) {
  return String(pathname || "").replace(/^\/[a-z]{2}(?:-[a-z]{2})?\//i, "/");
}

function isCollectionPage() {
  if (document.body && document.body.classList.contains("template-collection")) return true;
  const p = normalizePathname(location.pathname);
  return /^\/collections\/[^/]+/i.test(p);
}

function isSearchPage() {
  if (document.body && document.body.classList.contains("template-search")) return true;
  const p = normalizePathname(location.pathname);
  if (/^\/search(?:\/|$)/i.test(p)) return true;
  if (/^\/pages\/search(?:\/|$)/i.test(p)) return true;
  return false;
}

function initFsHomePageCardObserver() {
  if (window.__sgFsHomePageCardObserver) return;
  window.__sgFsHomePageCardObserver = true;

  const HOME_CARD_SELECTOR = [
    ".autocomplete-inner a.fs-product.item",
    ".fast-horizontal-products a.fs-product.item",
    ".autocomplete-inner .fs-product.item",
    ".fast-horizontal-products .fs-product.item"
  ].join(",");

  const enhanceCard = (card) => {
    if (!card || !(card instanceof HTMLElement)) return;

    const domData = sgExtractDataFromDomCard(card);
    sgApplyCardEnhancements(card, domData);

    const handle = sgExtractHandleFromCard(card);
    if (!handle) return;

    const prevHandle = card.dataset.sgHandleFetched;
    if (prevHandle === handle) return;
    card.dataset.sgHandleFetched = handle;

    sgFetchHomeCardDataByHandle(handle).then((shopifyData) => {
      const merged = {
        ...(domData || {}),
        ...(shopifyData || {}),
        tags:
          (domData?.tags && domData.tags.length ? domData.tags : shopifyData?.tags) || [],
        attributes:
          (domData?.attributes && domData.attributes.length ? domData.attributes : shopifyData?.attributes) || [],
        promotion:
          domData?.promotion || shopifyData?.promotion || ""
      };
      sgApplyCardEnhancements(card, merged);
    });
  };

  const applyAll = (root) => {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(HOME_CARD_SELECTOR).forEach((card) => {
      enhanceCard(card);
      setTimeout(() => enhanceCard(card), 180);
      setTimeout(() => enhanceCard(card), 450);
      setTimeout(() => enhanceCard(card), 800);
    });
  };

  applyAll(document);

  const mo = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches?.(HOME_CARD_SELECTOR)) {
          enhanceCard(node);
          setTimeout(() => enhanceCard(node), 180);
          setTimeout(() => enhanceCard(node), 450);
          setTimeout(() => enhanceCard(node), 800);
        }

        if (node.querySelectorAll) {
          applyAll(node);
        }
      });
    });
  });

  mo.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function hooks() {
  function traverseShadowRoots(rootNode, selector) {
    const seen = new Set();
    const queue = [rootNode];

    while (queue.length) {
      const node = queue.shift();
      if (!node || seen.has(node)) continue;
      seen.add(node);

      try {
        if (node.querySelector) {
          const found = node.querySelector(selector);
          if (found) return found;
        }
      } catch (_) {}

      const sr = node.shadowRoot;
      if (sr) queue.push(sr);

      const children = node.childNodes;
      if (children && children.length) {
        for (let i = 0; i < children.length; i++) queue.push(children[i]);
      }
    }
    return null;
  }

  function applyFsPageTypeClasses(targetEl) {
    const isCol = isCollectionPage();
    const isSea = isSearchPage();
    const page = isCol ? "collection" : isSea ? "search" : "other";

    document.documentElement.classList.toggle("sg-fs-collection", isCol);
    document.documentElement.classList.toggle("sg-fs-search", isSea);
    document.body.classList.toggle("sg-fs-collection", isCol);
    document.body.classList.toggle("sg-fs-search", isSea);

    const root = document.querySelector("#fast-simon-serp-app");
    if (root) {
      root.classList.toggle("sg-fs-collection", isCol);
      root.classList.toggle("sg-fs-search", isSea);
      root.setAttribute("data-sg-page", page);
    }

    if (targetEl && targetEl.classList) {
      targetEl.classList.toggle("sg-fs-collection", isCol);
      targetEl.classList.toggle("sg-fs-search", isSea);
      targetEl.setAttribute("data-sg-page", page);
    }

    let grid = null;
    const sr = root && root.shadowRoot ? root.shadowRoot : null;
    if (sr) grid = sr.querySelector(".filters-grid-wrapper");
    if (!grid) grid = traverseShadowRoots(document, ".filters-grid-wrapper");

    if (grid && grid.classList) {
      grid.classList.toggle("sg-fs-collection", isCol);
      grid.classList.toggle("sg-fs-search", isSea);
      grid.setAttribute("data-sg-page", page);
    }

    return !!grid;
  }

  applyFsPageTypeClasses(document.body);

  (function installFsPageTypeMaintainer() {
    if (window.__sgFsPageTypeMaintainer) return;
    window.__sgFsPageTypeMaintainer = true;

    let tries = 0;
    const iv = setInterval(() => {
      tries++;
      const ok = applyFsPageTypeClasses(document.body);
      if (ok || tries > 40) clearInterval(iv);
    }, 500);

    const mo = new MutationObserver(() => applyFsPageTypeClasses(document.body));
    mo.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener("popstate", () => applyFsPageTypeClasses(document.body));
  })();

  window.SerpOptions.registerHook("serp-top-page", ({ element }) => {
    if (!element) return;
    applyFsPageTypeClasses(element);

    const titleEl = element.querySelector(".fs-page-title");
    if (!titleEl) return;

    if (isCollectionPage()) {
      titleEl.classList.add("sg-fs-title-collection");
      titleEl.classList.remove("sg-fs-title-search");
    } else if (isSearchPage()) {
      titleEl.classList.add("sg-fs-title-search");
      titleEl.classList.remove("sg-fs-title-collection");
    } else {
      titleEl.classList.remove("sg-fs-title-search");
      titleEl.classList.remove("sg-fs-title-collection");
    }
  });

  window.SerpOptions.registerHook("serp-filters", ({ element }) => {
    if (!element) return;
    applyFsPageTypeClasses(element);

    element.querySelectorAll(".color-swatch-color-name").forEach((s) => {
      if (s.innerHTML === "White") s.classList.add("white");
    });

    const pageParent = element.closest("#fs-serp-page");
    if (pageParent && pageParent.querySelector(".filters-container") && window.innerWidth > 480) {
      addFilterButtons(pageParent);
      updateFilterButtons(pageParent);
    }
  });

  window.SerpOptions.registerHook("serp-product-grid", ({ products, element }) => {
    applyFsPageTypeClasses(element);

    getProductElements(element).forEach((productElement) => {
      const productID = productElement.dataset.productId;
      const data = products[productID];

      fsProductDataMap.set(productElement, data);

      productElement.querySelector(".my-promo-tags")?.remove();

      sgRenderUnifiedBadges(productElement, data);
      sgUpdatePriceRange(productElement, data);
      addprm(productElement, data);
      formatEuroPrice(productElement, data);
      runRemoveFromText(productElement);

      const imageCon = productElement.querySelector(".image-container");
      if (imageCon && !imageCon.classList.contains("first-img-quality-fix") && window.innerWidth < 480) {
        imageCon.classList.add("first-img-quality-fix");
        const img = imageCon.querySelector(".image");
        if (img) {
          const src = img.getAttribute("src") || "";
          if (src.includes("_657x.")) img.setAttribute("src", src.replace("_657x.", "."));
          else if (src.includes("_486x.")) img.setAttribute("src", src.replace("_486x.", "."));
          img.style.aspectRatio = "auto";
          img.style.imageRendering = "auto";
        }
      }

      moveBadge(productElement);

      const vendorEl = productElement.querySelector(".vendor-container");
      if (vendorEl) {
        const isBeautyRaw = GetattributevalueCI(data?.attributes, "My fields.isbeauty");
        const isBeauty = String(isBeautyRaw || "").trim().toLowerCase();

        const vendorName =
          GetattributevalueCI(data?.attributes, "vendor") ||
          GetattributevalueCI(data?.attributes, "brand") ||
          vendorEl.textContent ||
          "";

        const vendorHandle = String(vendorName)
          .trim()
          .toLowerCase()
          .replace(/['"]/g, "")
          .replace(/&/g, " and ")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");

        const rootUrl = window.Shopify?.routes?.root || "/";
        const vendorUrl = `${rootUrl}collections/${vendorHandle}`;

        if (isBeauty === "false" || isBeauty === "0" || isBeauty === "no") {
          vendorEl.style.setProperty("display", "none");
        } else {
          vendorEl.style.removeProperty("display");
          if (vendorHandle) {
            renderVendorLink(vendorEl, vendorName, vendorUrl);
          }
        }
      }

      replaceSwatchesWithCount(productElement);
    });

    setTimeout(copyhtmlTitle, 400);
    setTimeout(nofilterCheck, 400);
  });

  function hideFsSummarySearchTermOnCollection() {
    if (!isCollectionPage()) return;

    const SELECTOR = ".searchTerm.fs-summary-search-term";

    const apply = () => {
      const el = traverseShadowRoots(document, SELECTOR);
      if (!el) return false;
      if (el.dataset.sgHidden === "1") return true;
      el.style.display = "none";
      el.dataset.sgHidden = "1";
      return true;
    };

    apply();

    const mo = new MutationObserver(() => apply());
    mo.observe(document.documentElement, { childList: true, subtree: true });

    const iv = setInterval(() => {
      if (apply()) clearInterval(iv);
    }, 300);
  }

  function pinTopCenterContainerOnCollection() {
    if (!isCollectionPage()) return;

    const apply = () => {
      const root = document.querySelector("#fast-simon-serp-app");
      const sr = root && root.shadowRoot ? root.shadowRoot : null;
      if (!sr) return false;

      const el = sr.querySelector(".top-center-container");
      if (!el) return false;

      if (el.dataset.sgTopPinned === "1") return true;

      el.style.top = "0px";
      const pos = window.getComputedStyle(el).position;
      if (pos === "static") el.style.position = "relative";

      el.dataset.sgTopPinned = "1";
      return true;
    };

    apply();

    const mo = new MutationObserver(() => apply());
    mo.observe(document.documentElement, { childList: true, subtree: true });

    const iv = setInterval(() => {
      if (apply()) clearInterval(iv);
    }, 300);
  }

  function hooksFilter() {
    function updateZIndex(setTo) {
      const announcementSection = document.querySelector('#root > [class*="shopify-section-announcement"]');
      const headerSection = document.querySelector(".shopify-section-header");
      const bodyElement = document.querySelector("body");
      const htmlElement = document.querySelector("html");
      const z = setTo === -1 ? "-1" : "99";
      if (announcementSection) announcementSection.style.zIndex = z;
      if (headerSection) headerSection.style.zIndex = z;
      const ov = setTo === -1 ? "hidden" : "";
      bodyElement.style.overflowY = ov;
      htmlElement.style.overflowY = ov;
    }

    function handleBackgroundClick(filterModal) {
      filterModal.addEventListener("click", (e) => {
        const modalContent = filterModal.querySelector(".filters-modal");
        if (!modalContent || !modalContent.contains(e.target)) updateZIndex(99);
      });
    }

    function observeModalAddition() {
      const filterModal = traverseShadowRoots(document, ".filters-modal-wrapper.fs-result-page-j6l4zq");
      if (filterModal) {
        updateZIndex(-1);
        handleBackgroundClick(filterModal);
      } else {
        const observer = new MutationObserver((ml) => {
          ml.forEach((m) => {
            m.addedNodes.forEach(() => {
              const fm = traverseShadowRoots(document, ".filters-modal-wrapper.fs-result-page-j6l4zq");
              if (fm) {
                updateZIndex(-1);
                handleBackgroundClick(fm);
                observer.disconnect();
              }
            });
          });
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }

    function fastFilterButtonCheck() {
      const filterButton = traverseShadowRoots(document, ".filters-button-wrapper");
      if (filterButton) {
        filterButton.removeEventListener("click", handleFilterButtonClick);
        filterButton.addEventListener("click", handleFilterButtonClick);
      }
    }

    function handleFilterButtonClick() {
      observeModalAddition();
    }

    setInterval(fastFilterButtonCheck, 500);
    const observer = new MutationObserver((ml) => {
      ml.forEach((m) => {
        m.addedNodes.forEach(() => fastFilterButtonCheck());
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener("DOMContentLoaded", fastFilterButtonCheck);
  }

  hooksFilter();
  hideFsSummarySearchTermOnCollection();
  pinTopCenterContainerOnCollection();
}

function addFilterButtons(pageParent) {
  const filtersContainer = pageParent.querySelector(".filters-container");
  if (filtersContainer.querySelector(".filter-popup__bottom-buttons-fs")) return;

  const filterButtons = `<div class="filter-popup__bottom-buttons-fs">
      <a class="btn btn--outline pt-btn-disabled-fs">Clear</a>
      <button class="pt-apply btn">See Items</button>
    </div>`;
  filtersContainer.insertAdjacentHTML("beforeend", filterButtons);

  const clearButton = filtersContainer.querySelector("a.pt-btn-disabled-fs");
  const applyButton = filtersContainer.querySelector("button.pt-apply");

  clearButton?.addEventListener("click", () => {
    if (!clearButton.classList.contains("pt-btn-disabled-fs")) {
      document.dispatchEvent(new CustomEvent("send-fast-simon-params", { detail: { narrow: {} } }));
    }
  });

  applyButton?.addEventListener("click", () => {
    pageParent.querySelector(".filters-modal-wrapper")?.click();
  });

  setTimeout(() => updateFilterButtons(pageParent), 200);
}

function updateFilterButtons(pageParent) {
  const numOfFilters = pageParent.querySelectorAll(".removable-tags-wrapper .removable-tag").length;
  const clearButton = pageParent.querySelector(".filter-popup__bottom-buttons-fs a");
  const applyButton = pageParent.querySelector(".filter-popup__bottom-buttons-fs button");
  const resultsText = pageParent.querySelector(".fs-total-results-text")?.innerHTML.split(" ")[0];

  if (numOfFilters === 0) clearButton?.classList.add("pt-btn-disabled-fs");
  else clearButton?.classList.remove("pt-btn-disabled-fs");

  if (resultsText && applyButton) applyButton.innerHTML = `See ${resultsText} Results`;
}

function copyhtmlTitle() {
  const titleWrapper = document.querySelector(".collection-title__wrapper");
  const subcollections = document.querySelector(".collection-subcollections")?.outerHTML;
  const root = document.querySelector("#fast-simon-serp-app");
  const targetElement = root && root.shadowRoot ? root.shadowRoot.querySelector(".top-center-container") : null;

  if (titleWrapper && targetElement && !targetElement.querySelector(".acctitle")) {
    const htmlToPrepend = `<div class='acctitle'>${titleWrapper.innerHTML}</div>${subcollections || ""}`;
    targetElement.classList.add("sg-cltn");
    targetElement.insertAdjacentHTML("afterbegin", htmlToPrepend);
  }
}

function activateMatchingLinks() {
  const links = document.querySelectorAll(".collection-card__location");
  const currentUrlHandler = window.location.pathname.split("/").pop();
  links.forEach((link) => {
    const linkHrefHandler = link.getAttribute("href").split("/").pop();
    if (linkHrefHandler === currentUrlHandler) link.classList.add("active");
  });
}
document.addEventListener("DOMContentLoaded", activateMatchingLinks);

function nofilterCheck() {
  const root = document.querySelector("#fast-simon-serp-app");
  const filtersWrapper = root && root.shadowRoot ? root.shadowRoot.querySelector(".filters-grid-wrapper") : null;
  if (filtersWrapper?.classList.contains("filters-grid-no-filters")) {
    $(".blnkbx").remove();
    $(".collection-nav-grid, .collection-sub-grid").css("grid-template-columns", "unset");
  }
}

function openHeaderCartDrawerFallback() {
  const trigger =
    document.querySelector("[data-cart-link]") ||
    document.querySelector(".header__utils-link--cart") ||
    document.querySelector("[data-cart-toggle]");
  if (!trigger) return;
  trigger.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
}

function findDefaultVariantIdFromFsData(data) {
  if (!data) return null;
  if (data.selectedVariantId) return data.selectedVariantId;
  if (data.defaultVariantId) return data.defaultVariantId;
  if (Array.isArray(data.variants) && data.variants.length) {
    const firstAvail =
      data.variants.find((v) => v.available === true || v.isAvailable === true || v.isInStock === true) ||
      data.variants[0];
    return firstAvail.id || firstAvail.variantId || firstAvail.shopifyVariantId || null;
  }
  return null;
}

function initFsAtcDrawerSync() {
  if (window.__fsAtcDrawerBound) return;
  window.__fsAtcDrawerBound = true;

  document.addEventListener(
    "click",
    function (e) {
      let btn = null;
      let path = e.composedPath ? e.composedPath() : null;

      if (path) {
        for (let i = 0; i < path.length; i++) {
          const node = path[i];
          if (node && node.nodeType === 1 && node.matches && node.matches(".fs-add-to-cart-button")) {
            btn = node;
            break;
          }
        }
      }

      if (!btn && e.target && e.target.closest) {
        btn = e.target.closest(".fs-add-to-cart-button");
      }

      if (!btn) return;

      let productElement = null;
      if (path) {
        for (let i = 0; i < path.length; i++) {
          const node = path[i];
          if (node && node.nodeType === 1 && node.classList && node.classList.contains("fs-results-product-card")) {
            productElement = node;
            break;
          }
        }
      }
      if (!productElement && btn.closest) {
        productElement = btn.closest(".fs-results-product-card");
      }

      const data = productElement ? fsProductDataMap.get(productElement) : null;
      const variants = Array.isArray(data?.variants) ? data.variants : [];

      if (!data || variants.length > 1) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const variantIdRaw = findDefaultVariantIdFromFsData(data);
      if (!variantIdRaw) {
        const url = findProductUrlFromCard(productElement || document);
        if (url) window.location.href = url;
        return;
      }

      const match = String(variantIdRaw).match(/\d+$/);
      const variantId = match ? match[0] : variantIdRaw;

      const addUrl =
        typeof routes !== "undefined" && routes.cart_add_url ? `${routes.cart_add_url}.js` : "/cart/add.js";

      fetch(addUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then((r) => r.json().catch(() => null))
        .then(() => {
          const sectionsUrl = `${window.location.pathname}?sections=cart-drawer,cart-counter`;
          return fetch(sectionsUrl, { credentials: "same-origin" });
        })
        .then((r) => r.text())
        .then((text) => {
          let json = null;
          try {
            json = JSON.parse(text);
          } catch (e) {
            openHeaderCartDrawerFallback();
            return;
          }

          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer && typeof cartDrawer.renderContents === "function") {
            try {
              cartDrawer.renderContents({ sections: json }, true);
            } catch (e) {
              openHeaderCartDrawerFallback();
            }
          } else {
            openHeaderCartDrawerFallback();
          }
        })
        .catch(() => openHeaderCartDrawerFallback());
    },
    true
  );
}

initFsAtcDrawerSync();

if (window.SerpOptions) {
  hooks();
} else {
  window.addEventListener("fast-serp-ready", hooks);
}

initFsHomePageCardObserver();

/* =====================================================================
   A11Y-1 · Predictive search combobox bridge (WCAG 4.1.2, 2.1.1)

   Fast Simon takes over the theme's <predictive-search> input and renders
   its suggestion panel inside a shadow root on a body-level container
   (.fast-ac-container / .mobile-fast-ac-container). The theme's own
   predictive-search.js never runs, so the input kept aria-expanded="false"
   and pointed at an empty theme panel. This keeps the two trees in sync:
   aria-controls targets the vendor container while it is open, the panel is
   named and typed as the dialog it is, product results are exposed as
   options, aria-expanded follows the panel, arrow keys walk every
   suggestion, results are announced, and Esc closes the panel without
   wiping the query.
   ===================================================================== */
(function () {
  var FS_LIST_ID = 'predictive-search-results-list-fs';
  var suppressed = false;
  // the theme closes the whole search drawer on the Escape keyup; one Escape should only close the suggestions
  var swallowEscapeUp = false;
  // when the user last typed in the field; used to re-show results the vendor rendered but left hidden
  var lastInputAt = 0;
  var lastAnnounced = -1;

  function isSearchInput(el) {
    return !!el && el.tagName === 'INPUT' && el.getAttribute('role') === 'combobox' &&
      (el.classList.contains('fast-autocomplete') || /^search-/.test(el.id));
  }

  function getInput() {
    var all = document.querySelectorAll('input[role="combobox"]');
    for (var i = 0; i < all.length; i++) {
      if (isSearchInput(all[i]) && (all[i] === document.activeElement || all[i].getClientRects().length)) { return all[i]; }
    }
    for (i = 0; i < all.length; i++) { if (isSearchInput(all[i])) { return all[i]; } }
    return null;
  }

  // The field counts as in use only while it is shown and, when it sits in the theme's
  // search drawer, while that drawer is open. The theme empties the field as the drawer
  // closes and the vendor re-renders its default suggestions on that; those are not for
  // the user.
  function fieldUsable(input) {
    if (!input || !input.getClientRects().length) { return false; }
    var details = input.closest('details');
    return !(details && !details.open);
  }

  function statusOf(input) {
    var host = input && input.closest('predictive-search');
    return (host && host.querySelector('.js-search-status')) || document.querySelector('.js-search-status');
  }

  function containers() {
    return document.querySelectorAll('.fast-ac-container, .mobile-fast-ac-container');
  }

  function panelOf(container) {
    return container && container.shadowRoot ? container.shadowRoot.querySelector('.autocomplete') : null;
  }

  function activeContainer() {
    var all = containers();
    for (var i = 0; i < all.length; i++) {
      if (panelOf(all[i]) && window.getComputedStyle(all[i]).display !== 'none') { return all[i]; }
    }
    return null;
  }

  function optionsOf(container) {
    return container && container.shadowRoot ? container.shadowRoot.querySelectorAll('.fast-ac-item') : [];
  }

  // Every suggestion across all sections (recent, popular, category, product, turbolink)
  // in DOM order. The vendor only handles arrow keys inside one section, so the bridge
  // owns the whole traversal.
  function itemsOf(container) {
    return Array.prototype.slice.call(optionsOf(container)).filter(function (el) {
      return el.offsetParent !== null || el.getClientRects().length > 0;
    });
  }

  function strings() {
    return (window.theme && window.theme.a11y) || {};
  }

  // Counts are announced for a typed query only. The vendor also renders its default
  // panel (recent and popular searches) whenever the field is empty, including right
  // after it clears the field itself on Escape; that is not a result of anything the
  // user asked for.
  function announceResults(input, count) {
    var region = statusOf(input);
    if (!region || !input.value.trim()) { lastAnnounced = -1; return; }
    if (count === lastAnnounced) { return; }
    lastAnnounced = count;
    var t = strings();
    var template = count === 1 ? t.search_results_one : t.search_results_other;
    if (!template) { return; }
    region.textContent = '';
    window.setTimeout(function () {
      // re-checked here: the vendor also re-renders while the drawer is closing and
      // the field is being emptied, and by now focus has already left
      var a = document.activeElement, active = activeContainer();
      var inField = a === input || !!(active && (a === active || active.contains(a)));
      if (!inField || !fieldUsable(input) || !input.value.trim()) { lastAnnounced = -1; return; }
      region.textContent = template.replace('9999', count);
    }, 120);
  }

  function clearAnnouncement(input) {
    var region = statusOf(input);
    lastAnnounced = -1;
    if (region) { region.textContent = ''; }
  }

  function moveTo(items, index) {
    if (!items.length) { return false; }
    var i = index;
    if (i < 0) { i = items.length - 1; }
    if (i >= items.length) { i = 0; }
    items[i].focus();
    return true;
  }

  function currentIndex(items) {
    var a = document.activeElement;
    while (a && a.shadowRoot && a.shadowRoot.activeElement) { a = a.shadowRoot.activeElement; }
    for (var i = 0; i < items.length; i++) {
      if (items[i] === a || items[i].contains(a)) { return i; }
    }
    return -1;
  }

  function ownControls(input) {
    if (!input.dataset.a11yOwnControls) {
      input.dataset.a11yOwnControls = input.getAttribute('aria-controls') || '';
    }
    return input.dataset.a11yOwnControls;
  }

  function sync() {
    var input = getInput();
    if (!input) { return; }
    var own = ownControls(input);

    var active = activeContainer(),
      all = containers(),
      i;

    for (i = 0; i < all.length; i++) {
      if (all[i] !== active && all[i].id === FS_LIST_ID) { all[i].removeAttribute('id'); }
    }

    if (!active && !suppressed && Date.now() - lastInputAt < 2000 && document.activeElement === input) {
      // The vendor rendered suggestions for what the user is typing but left the panel
      // hidden (its open/closed state goes stale after the drawer was closed or the
      // query was briefly too short). Results that were just rendered for the current
      // query are meant to be seen.
      for (i = 0; i < all.length; i++) {
        if (panelOf(all[i]) && optionsOf(all[i]).length && window.getComputedStyle(all[i]).display === 'none') {
          all[i].style.display = 'block';
          active = all[i];
          break;
        }
      }
    }

    if (!active) {
      if (own) { input.setAttribute('aria-controls', own); } else { input.removeAttribute('aria-controls'); }
      if (input.getAttribute('aria-expanded') !== 'false') { input.setAttribute('aria-expanded', 'false'); }
      lastAnnounced = -1;
      return;
    }

    if (active.id !== FS_LIST_ID) { active.id = FS_LIST_ID; }

    var panel = panelOf(active);
    if (panel) {
      // the vendor sets aria-expanded / aria-autocomplete on the panel itself, which
      // contradicts the input and is not allowed on a generic element
      if (panel.hasAttribute('aria-expanded')) { panel.removeAttribute('aria-expanded'); }
      if (panel.hasAttribute('aria-autocomplete')) { panel.removeAttribute('aria-autocomplete'); }
      // Name and type the popup to match what it actually is. Not aria-modal: the panel
      // does not trap focus and the rest of the page stays reachable.
      if (panel.getAttribute('role') !== 'dialog') { panel.setAttribute('role', 'dialog'); }
      var panelLabel = strings().search_panel_label;
      if (panelLabel && panel.getAttribute('aria-label') !== panelLabel) {
        panel.setAttribute('aria-label', panelLabel);
      }
    }

    // Only the product results live in the vendor's listbox. The other sections
    // (recent, popular, category) are link lists, not listbox items, so role=option
    // there would break aria-required-parent and nest a link inside an interactive element.
    var listbox = active.shadowRoot ? active.shadowRoot.querySelector('[role="listbox"]') : null;
    if (listbox) {
      var options = listbox.querySelectorAll('.fast-ac-item');
      for (i = 0; i < options.length; i++) {
        if (options[i].getAttribute('role') !== 'option') { options[i].setAttribute('role', 'option'); }
        if (!options[i].id) { options[i].id = 'predictive-search-option-' + (i + 1); }
      }
    }

    // The vendor's section headers expose themselves as banner landmarks. Demote them
    // to headings so the sections stay findable without polluting the landmark list.
    var headers = active.shadowRoot ? active.shadowRoot.querySelectorAll('.fs-autocomplete-header') : [];
    for (i = 0; i < headers.length; i++) {
      if (headers[i].getAttribute('role') !== 'heading') {
        headers[i].setAttribute('role', 'heading');
        headers[i].setAttribute('aria-level', '3');
      }
    }

    input.setAttribute('aria-controls', FS_LIST_ID);
    if (input.getAttribute('aria-expanded') !== 'true') { input.setAttribute('aria-expanded', 'true'); }
    // Only while the user is in the field or in the panel. The vendor also re-renders
    // when the drawer closes and the field is emptied; that must not be announced.
    var a = document.activeElement;
    if (fieldUsable(input) && (a === input || a === active || active.contains(a))) {
      announceResults(input, itemsOf(active).length);
    } else {
      lastAnnounced = -1;
    }
  }

  function closePanel(input) {
    var all = containers();
    for (var i = 0; i < all.length; i++) {
      // remember how the vendor had it (inline "block" while open), so the panel can
      // come back the same way when the user keeps typing
      all[i].dataset.a11yPrevDisplay = all[i].style.display;
      all[i].style.display = 'none';
    }
    suppressed = true;
    clearAnnouncement(input);
    sync();
  }

  // Called when the user types again. The vendor keeps its own "open" state and does
  // not re-show a panel that was hidden from outside, so its inline "block" is put
  // back; the vendor then fills it with the results for the new query.
  function allowPanel(input) {
    if (!suppressed) { return; }
    suppressed = false;
    var keep = !!(input && input.value);
    var all = containers();
    for (var i = 0; i < all.length; i++) {
      var prev = all[i].dataset.a11yPrevDisplay || '';
      delete all[i].dataset.a11yPrevDisplay;
      all[i].style.display = keep && prev !== 'none' ? prev : '';
    }
    sync();
  }

  var panelObserver = new MutationObserver(sync);

  // Fast Simon may write an instruction string ("Search and use arrows or TAB to navigate
  // results") onto the input as its aria-label. The theme names the input with a
  // visually-hidden <label for>, so only that instruction text is stripped.
  var VENDOR_NAME = /use arrows|tab to navigate|navigate results/i;

  function fixName(el) {
    var label = el.getAttribute('aria-label');
    if (label && VENDOR_NAME.test(label)) { el.removeAttribute('aria-label'); }
    if (el.hasAttribute('aria-owns')) { el.removeAttribute('aria-owns'); }
  }

  var nameObserver = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) { fixName(records[i].target); }
  });

  function watchInputs() {
    var all = document.querySelectorAll('input[role="combobox"]');
    for (var i = 0; i < all.length; i++) {
      if (isSearchInput(all[i]) && !all[i].dataset.a11yNameWatched) {
        all[i].dataset.a11yNameWatched = '1';
        ownControls(all[i]);
        fixName(all[i]);
        nameObserver.observe(all[i], { attributes: true, attributeFilter: ['aria-label', 'aria-owns'] });
      }
    }
  }

  function watchContainers() {
    watchInputs();
    var all = containers();
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot && !all[i].dataset.a11yWatched) {
        all[i].dataset.a11yWatched = '1';
        panelObserver.observe(all[i].shadowRoot, { childList: true, subtree: true });
      }
    }
    sync();
  }

  function start() {
    new MutationObserver(watchContainers).observe(document.body, { childList: true });
    watchContainers();

    // the vendor script initialises late and may replace the input; re-arm for a while
    var rearm = window.setInterval(watchContainers, 500);
    window.setTimeout(function () { window.clearInterval(rearm); }, 15000);

    document.addEventListener('keydown', function (e) {
      var fromInput = isSearchInput(e.target);
      var input = fromInput ? e.target : getInput();
      var active = activeContainer();
      // the event target is the shadow host when focus sits on a suggestion
      var insidePanel = !fromInput && !!active && (e.target === active || active.contains(e.target));
      if (!fromInput && !insidePanel) { return; }

      if (e.key === 'Escape' || e.key === 'Esc') {
        // without this, type="search" clears the query and the panel stays behind
        if (active) {
          e.preventDefault();
          e.stopPropagation();
          swallowEscapeUp = true;
          closePanel(input);
          if (input) { input.focus(); }
        }
        return;
      }

      if (!active) { return; }
      var items = itemsOf(active);
      if (!items.length) { return; }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        e.stopPropagation();
        moveTo(items, fromInput ? 0 : currentIndex(items) + 1);
        return;
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        e.stopPropagation();
        if (fromInput) { moveTo(items, items.length - 1); return; }
        var i = currentIndex(items);
        // from the first suggestion, go back to the query field
        if (i <= 0) { if (input) { input.focus(); } return; }
        moveTo(items, i - 1);
        return;
      }

      if (e.key === 'Home' && insidePanel) { e.preventDefault(); moveTo(items, 0); return; }
      if (e.key === 'End' && insidePanel) { e.preventDefault(); moveTo(items, items.length - 1); }
    }, true);

    document.addEventListener('keyup', function (e) {
      if (!swallowEscapeUp) { return; }
      swallowEscapeUp = false;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    document.addEventListener('input', function (e) {
      if (isSearchInput(e.target)) { lastInputAt = Date.now(); allowPanel(e.target); }
    }, true);

    // Leaving the field does not end the suppression: the vendor does not hide its panel
    // on blur, so re-allowing it there would bring back a panel the user just dismissed.
    // It stays hidden until the user types in the field again.
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
